// @ts-nocheck
// Paints the Mo–Fr week chrome. Both swipe surfaces call render() with a weekView().
(() => {
  'use strict';

  const tr = window.vhpT; // snippets/vhp-i18n.liquid

  if (window.vhpSwipeWeek) return;

  const SESSION_KEY = 'vhp_week_celebrated';
  const FALLBACK = ['#2D4A2A', '#C2542A', '#D4993A', '#4A7043', '#8A5A2A'];
  const FAN_MAX = 5;
  const FAN_STEP = 8; // degrees between two fan cards, centred: 5 cards = -16 … 16

  const stages = new WeakMap();

  const reduced = () => {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  };

  const sessionCelebrated = () => {
    try {
      return sessionStorage.getItem(SESSION_KEY) === '1';
    } catch (e) {
      return false;
    }
  };

  const markSession = () => {
    try {
      sessionStorage.setItem(SESSION_KEY, '1');
    } catch (e) { /* private mode */ }
  };

  const clearSession = () => {
    try {
      sessionStorage.removeItem(SESSION_KEY);
    } catch (e) { /* private mode */ }
  };

  const stageState = (stage) => {
    let state = stages.get(stage);
    if (!state) {
      state = {
        baseline: null,
        prevFilled: null,
        celebrated: false,
        successOpen: false,
        sheetOpen: false,
        opts: {},
      };
      stages.set(stage, state);
    }
    return state;
  };

  const num = (value) => {
    if (value == null || value === '') return null;
    const n = Number(value);
    return Number.isFinite(n) ? n : null;
  };

  const metaLine = (item) => {
    const parts = [];
    const protein = num(item?.protein);
    const time = num(item?.time);
    if (protein != null) parts.push(tr('common.protein', { n: Math.round(protein) }));
    if (time != null && time > 0) parts.push(tr('common.min', { n: Math.round(time) }));
    return parts.join(' · ');
  };

  // Dock button while the plan is not ready: what the ready rule (3 likes incl. 1 main) still needs.
  const ctaWaitLabel = (view) => {
    const left = Number(view.readyLeft) || 0;
    if (view.needMain && left <= 1) return tr('week.like_main');
    return tr('week.like_more', { n: left });
  };

  const checkSvg = () => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '14');
    svg.setAttribute('height', '14');
    svg.setAttribute('aria-hidden', 'true');
    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M5 12.5 10 17.5 19 7.5');
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '2.4');
    path.setAttribute('stroke-linecap', 'round');
    path.setAttribute('stroke-linejoin', 'round');
    svg.append(path);
    return svg;
  };

  const thumb = (item, index) => {
    const el = document.createElement('span');
    el.className = 'vhp-sw-thumb';
    if (item?.image) {
      const img = document.createElement('img');
      img.alt = '';
      img.src = item.image;
      el.append(img);
    } else {
      el.classList.add('is-fallback');
      el.style.background = FALLBACK[index % FALLBACK.length];
    }
    return el;
  };

  const setExpanded = (stage, open) => {
    stage.querySelectorAll('[data-vhp-week-open]').forEach((el) => {
      el.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  };

  const paintDays = (stage, view) => {
    const box = stage.querySelector('[data-vhp-sw-days]');
    if (!box) return;
    const state = stageState(stage);
    const popIndex = state.prevFilled != null && view.filled > state.prevFilled ? view.filled - 1 : -1;
    state.prevFilled = view.filled;
    box.setAttribute('aria-label', tr('week.days_label', { filled: view.filled, goal: view.goal }));
    box.replaceChildren();
    view.slots.forEach((slot, index) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = `vhp-sw-day is-${slot.state}`;
      btn.setAttribute('data-vhp-week-open', '');
      btn.setAttribute('aria-haspopup', 'dialog');
      btn.setAttribute('aria-expanded', stageState(stage).sheetOpen ? 'true' : 'false');
      const label = slot.state === 'filled' ? tr('week.slot_filled') : slot.state === 'next' ? tr('week.slot_next') : tr('week.slot_free');
      btn.setAttribute('aria-label', `${slot.day}, ${label}`);
      const mark = document.createElement('span');
      mark.className = 'vhp-sw-day__mark';
      mark.setAttribute('aria-hidden', 'true');
      if (slot.state === 'filled') mark.append(checkSvg());
      if (index === popIndex) mark.classList.add('is-pop');
      const name = document.createElement('span');
      name.className = 'vhp-sw-day__name';
      name.textContent = slot.day;
      btn.append(mark, name);
      box.append(btn);
    });
  };

  const paintSheet = (stage, view) => {
    const title = stage.querySelector('[data-vhp-week-sheet-title]');
    if (title) {
      title.replaceChildren();
      title.append(document.createTextNode(tr('week.sheet_count', { filled: view.filled, goal: view.goal })));
      const em = document.createElement('em');
      em.textContent = tr('week.sheet_mains');
      title.append(em);
    }
    const body = stage.querySelector('[data-vhp-week-sheet-body]');
    if (!body) return;
    const scroll = body.scrollTop;
    body.replaceChildren();

    const auto = document.createElement('p');
    auto.className = 'vhp-sw-auto';
    const tick = document.createElement('span');
    tick.className = 'vhp-sw-auto__tick';
    tick.setAttribute('aria-hidden', 'true');
    tick.append(checkSvg());
    auto.append(tick, document.createTextNode(tr('common.auto_sides')));
    body.append(auto);

    const names = (view.sides || []).map((item) => item.title).filter(Boolean);
    if (names.length) {
      const extra = document.createElement('p');
      extra.className = 'vhp-sw-auto-likes';
      extra.textContent = tr('week.sides', { names: names.join(', ') });
      body.append(extra);
    }

    const list = document.createElement('ul');
    list.className = 'vhp-sw-rows';
    view.slots.forEach((slot, index) => {
      const li = document.createElement('li');
      li.className = `vhp-sw-row is-${slot.state}`;
      const day = document.createElement('span');
      day.className = 'vhp-sw-row__day';
      day.textContent = slot.day;
      if (slot.item) {
        const text = document.createElement('span');
        text.className = 'vhp-sw-row__text';
        const strong = document.createElement('strong');
        strong.textContent = slot.item.title || tr('common.recipe');
        text.append(strong);
        const meta = metaLine(slot.item);
        if (meta) {
          const sub = document.createElement('span');
          sub.textContent = meta;
          text.append(sub);
        }
        li.append(day, thumb(slot.item, index), text);
      } else {
        const note = document.createElement('span');
        note.className = 'vhp-sw-row__note';
        note.textContent = slot.state === 'next' ? tr('week.next_here') : tr('week.free');
        li.append(day, note);
      }
      list.append(li);
    });
    body.append(list);

    if (view.extra && view.extra.length) {
      const more = document.createElement('p');
      more.className = 'vhp-sw-extra';
      more.textContent = tr('week.extra', { n: view.extra.length });
      body.append(more);
    }
    body.scrollTop = scroll;
  };

  // Their liked dishes as a fan: the week's mains first, then other likes (a ready plan can have one main), centred.
  const paintFan = (stage, view) => {
    const fan = stage.querySelector('[data-vhp-week-fan]');
    if (!fan) return;
    fan.replaceChildren();
    const items = [...view.slots.map((slot) => slot.item).filter(Boolean), ...(view.sides || [])].slice(0, FAN_MAX);
    items.forEach((item, index) => {
      const card = document.createElement('span');
      card.className = 'vhp-sw-fan__card';
      card.style.setProperty('--rot', `${(index - (items.length - 1) / 2) * FAN_STEP}deg`);
      card.style.setProperty('--i', String(index));
      if (item.image) {
        const img = document.createElement('img');
        img.alt = '';
        img.src = item.image;
        card.append(img);
      } else {
        card.style.background = FALLBACK[index % FALLBACK.length];
      }
      fan.append(card);
    });
  };

  const pauseMedia = (stage) => {
    stage.querySelectorAll('[data-vhp-swipe-media] video').forEach((video) => {
      try { video.pause(); } catch (e) { /* ignore */ }
    });
  };

  const resumeMedia = (stage) => {
    const state = stageState(stage);
    if (state.successOpen || state.sheetOpen) return;
    stage.querySelectorAll('[data-vhp-swipe-media] video').forEach((video) => {
      // Paused by a tap on the card: stays paused.
      if (video.paused && video.dataset.userPaused !== '1') void video.play().catch(() => {});
    });
  };

  const closeSheet = (stage) => {
    const sheet = stage.querySelector('[data-vhp-week-sheet]');
    const state = stageState(stage);
    if (!sheet || !state.sheetOpen) return;
    state.sheetOpen = false;
    setExpanded(stage, false);
    sheet.classList.remove('is-open');
    const hide = () => {
      if (!state.sheetOpen) sheet.hidden = true;
    };
    if (reduced()) hide();
    else {
      sheet.addEventListener('transitionend', hide, { once: true });
      window.setTimeout(hide, 480);
    }
  };

  const openSheet = (stage) => {
    const sheet = stage.querySelector('[data-vhp-week-sheet]');
    const state = stageState(stage);
    if (!sheet || state.opts.swap) return;
    const head = stage.querySelector('[data-vhp-week-head]');
    const top = head?.closest('.vhp-reel-top') || head;
    if (top) stage.style.setProperty('--vhp-sw-head', `${top.offsetHeight + 12}px`);
    pauseMedia(stage);
    state.sheetOpen = true;
    setExpanded(stage, true);
    sheet.hidden = false;
    if (reduced()) sheet.classList.add('is-open');
    else requestAnimationFrame(() => sheet.classList.add('is-open'));
    sheet.querySelector('[data-vhp-week-sheet-title]')?.focus({ preventScroll: true });
  };

  const closeSuccess = (stage, forget) => {
    const el = stage.querySelector('[data-vhp-week-success]');
    const state = stageState(stage);
    state.successOpen = false;
    if (el) {
      el.classList.remove('is-on');
      el.hidden = true;
    }
    if (forget) {
      state.celebrated = false;
      clearSession();
    }
  };

  // The moment the week is full: a tick badge on the fan, a burst of confetti from behind it, a short buzz
  // (Android). Pure decoration, rebuilt each time.
  const CONFETTI = ['#b8d4b0', '#f7f4ee', '#f2c14e', '#5fd38d', '#ff8a65'];
  const celebrate = (el) => {
    el.querySelectorAll('.vhp-sw-success__badge, .vhp-sw-success__confetti').forEach((node) => node.remove());
    const fan = el.querySelector('[data-vhp-week-fan]');
    if (fan) {
      const badge = document.createElement('span');
      badge.className = 'vhp-sw-success__badge';
      badge.setAttribute('aria-hidden', 'true');
      badge.innerHTML = '<svg viewBox="0 0 24 24" fill="none"><path d="M6 12.5l4 4 8-9" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      fan.append(badge);
    }
    const burst = document.createElement('div');
    burst.className = 'vhp-sw-success__confetti';
    burst.setAttribute('aria-hidden', 'true');
    for (let i = 0; i < 28; i += 1) {
      const bit = document.createElement('i');
      const angle = (Math.PI * 2 * i) / 28 + Math.random() * 0.4;
      const dist = 90 + Math.random() * 110;
      bit.style.setProperty('--dx', `${Math.cos(angle) * dist}px`);
      bit.style.setProperty('--dy', `${Math.sin(angle) * dist - 50}px`);
      bit.style.setProperty('--r', `${Math.random() * 540 - 270}deg`);
      bit.style.background = CONFETTI[i % CONFETTI.length];
      burst.append(bit);
    }
    el.prepend(burst);
    window.setTimeout(() => burst.remove(), 2000);
    try {
      navigator.vibrate?.([12, 60, 18]);
    } catch (e) {
      /* no haptics */
    }
  };

  const openSuccess = (stage, view) => {
    const el = stage.querySelector('[data-vhp-week-success]');
    const state = stageState(stage);
    if (!el || state.successOpen) return;
    closeSheet(stage);
    paintFan(stage, view);
    state.successOpen = true;
    state.celebrated = true;
    markSession();
    state.opts?.onSuccess?.();
    pauseMedia(stage);
    el.classList.toggle('is-reduced', reduced());
    el.hidden = false;
    if (!reduced()) celebrate(el);
    if (reduced()) el.classList.add('is-on');
    else requestAnimationFrame(() => el.classList.add('is-on'));
    el.querySelector('[data-vhp-week-success-plan]')?.focus({ preventScroll: true });
  };

  const paintDock = (stage, view, opts) => {
    const dock = stage.querySelector('[data-vhp-week-dock]');
    if (!dock) return;
    dock.hidden = Boolean(opts.swap);
    const paid = Boolean(opts.paid);
    dock.classList.toggle('is-paid', paid);
    dock.classList.toggle('is-ready', Boolean(view.ready) && !paid);
    const cta = dock.querySelector('[data-vhp-week-cta]');
    const paidLink = dock.querySelector('[data-vhp-week-paid]');
    // "Überspringen – ich wähle für dich aus": only where the page plans without likes (opts.onSkip), until ready.
    const skip = dock.querySelector('[data-vhp-week-skip]');
    const canSkip = typeof opts.onSkip === 'function' && !paid && !opts.swap && !view.ready;
    dock.classList.toggle('has-skip', canSkip);
    if (skip) {
      skip.hidden = !canSkip;
      skip.disabled = Boolean(opts.planBusy);
      // opts.skipLabel: the page's own words for the same action (the planner says "Reicht schon?" after one like).
      if (!skip.dataset.plain) skip.dataset.plain = skip.textContent;
      const label = opts.skipLabel || skip.dataset.plain;
      if (skip.textContent !== label) skip.textContent = label;
    }
    if (cta) {
      const ready = Boolean(view.ready);
      cta.hidden = paid;
      cta.classList.toggle('is-ready', ready);
      cta.setAttribute('aria-disabled', ready && !opts.planBusy ? 'false' : 'true');
      cta.textContent = ready ? tr('common.create_plan') : ctaWaitLabel(view);
    }
    stage.querySelector('[data-vhp-week-sheet]')?.classList.toggle('is-ready', Boolean(view.ready) && !paid);
    if (paidLink) {
      paidLink.hidden = !paid;
      if (opts.plannerUrl) paidLink.setAttribute('href', opts.plannerUrl);
    }
    stage.querySelectorAll('[data-vhp-week-plan]').forEach((btn) => {
      btn.hidden = paid || !view.ready;
      btn.disabled = Boolean(opts.planBusy);
    });
    const successPlan = stage.querySelector('[data-vhp-week-success-plan]');
    if (successPlan) successPlan.disabled = Boolean(opts.planBusy);
  };

  const onClick = (stage, event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const state = stageState(stage);
    if (target.closest('[data-vhp-week-open]')) {
      event.preventDefault();
      openSheet(stage);
      return;
    }
    if (target.closest('[data-vhp-week-success-more]')) {
      event.preventDefault();
      closeSuccess(stage, false);
      resumeMedia(stage);
      return;
    }
    if (target.closest('[data-vhp-week-close]')) {
      event.preventDefault();
      closeSheet(stage);
      resumeMedia(stage);
      return;
    }
    if (target.closest('[data-vhp-week-skip]')) {
      event.preventDefault();
      if (state.opts.planBusy || typeof state.opts.onSkip !== 'function') return;
      closeSheet(stage);
      state.opts.onSkip();
      return;
    }
    const cta = target.closest('[data-vhp-week-cta]');
    if (cta) {
      event.preventDefault();
      if (cta.getAttribute('aria-disabled') === 'true') {
        // Not ready yet: a small nudge instead of an action (the label says what is missing).
        cta.classList.remove('is-nudge');
        void cta.offsetWidth;
        cta.classList.add('is-nudge');
        return;
      }
      if (state.opts.planBusy) return;
      closeSheet(stage);
      closeSuccess(stage, false);
      if (typeof state.opts.onPlan === 'function') state.opts.onPlan();
      return;
    }
    if (target.closest('[data-vhp-week-plan], [data-vhp-week-success-plan]')) {
      event.preventDefault();
      if (state.opts.planBusy) return;
      closeSheet(stage);
      closeSuccess(stage, false);
      if (typeof state.opts.onPlan === 'function') state.opts.onPlan();
    }
  };

  const onKey = (stage, event) => {
    if (event.key !== 'Escape') return;
    const state = stageState(stage);
    if (state.successOpen) {
      event.stopPropagation();
      closeSuccess(stage, false);
      return;
    }
    if (state.sheetOpen) {
      event.stopPropagation();
      closeSheet(stage);
    }
  };

  const bind = (stage) => {
    if (stage.dataset.vhpSwipeWeekBound === '1') return;
    stage.dataset.vhpSwipeWeekBound = '1';
    stage.addEventListener('click', (event) => onClick(stage, event));
    stage.addEventListener('keydown', (event) => onKey(stage, event));
  };

  // options.celebrateAt: 'full' (default) = "Deine Woche steht" once the 5 weekday mains are liked; 'ready' = once the
  // likes make a plan (3 incl. a main, vhp-planner-likes.js planReady), the rule the Plan tab and the planner use.
  const render = (stage, view, opts) => {
    if (!stage || !view) return;
    const options = opts || {};
    const state = stageState(stage);
    state.opts = options;
    bind(stage);

    const done = options.celebrateAt === 'ready' ? Boolean(view.ready) : view.filled >= view.goal;
    if (state.baseline == null) {
      // Done on arrival (a returning visitor): no celebration for it.
      state.baseline = done;
      state.celebrated = done || sessionCelebrated();
    }

    const head = stage.querySelector('[data-vhp-week-head]');
    const main = stage.querySelector('[data-vhp-week-main]');
    const swap = stage.querySelector('[data-vhp-sw-swap]');
    if (head) head.hidden = false;
    if (main) main.hidden = Boolean(options.swap);
    if (swap) {
      swap.hidden = !options.swap;
      swap.textContent = options.swapLabel || '';
    }

    const count = stage.querySelector('[data-vhp-week-count]');
    if (count) {
      // The unit is its own span so the planner's one-line strip can drop it (assets/vhp-planner-tinder.css).
      const unit = document.createElement('span');
      unit.className = 'vhp-sw-head__unit';
      // Planner setup (options.readyCount): likes toward a ready plan ("1/3 Likes") until it is ready, so the count
      // doesn't read as 5 needed; then the mains of the week as everywhere.
      const toReady = options.readyCount && !view.ready ? Number(options.readyCount) : 0;
      unit.textContent = toReady ? tr('week.likes_unit') : tr('week.mains_unit');
      count.replaceChildren(
        toReady ? `${Math.max(0, toReady - (Number(view.readyLeft) || 0))}/${toReady}` : `${view.filled}/${view.goal}`,
        unit
      );
    }

    if (!options.swap) {
      paintDays(stage, view);
      paintSheet(stage, view);
    }
    paintDock(stage, view, options);

    const blockSuccess = Boolean(options.swap || options.paid || options.allowSuccess === false);
    if (blockSuccess) {
      closeSuccess(stage, false);
      if (options.swap) closeSheet(stage);
      return;
    }
    if (!done) {
      if (state.successOpen) closeSuccess(stage, true);
      return;
    }
    if (!state.celebrated && !state.baseline) openSuccess(stage, view);
  };

  window.vhpSwipeWeek = {
    render,
    holding: (stage) => {
      const state = stage ? stages.get(stage) : null;
      return Boolean(state && (state.successOpen || state.sheetOpen));
    },
  };
})();
